import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Prediction } from "../types/common";
import { getDigimonInfo } from "../utils/common";
import ClassAndPercent from "./ClassAndPercent";
import ImageSaveButton from "./ImageSaveButton";

interface Props {
  result: Prediction;
}

const ResultContent = ({ result }: Props) => {
  console.log(result?.map(({ className }) => className));
  const [digimonInfo, setDigimonInfo] = useState<{
    title: string;
    image: string;
    desc: string;
    percent: number;
  }>({ title: "", image: "", desc: "", percent: 0 });

  useEffect(() => {
    if (result && result.length > 0) {
      const digimon = getDigimonInfo(result[0].className);
      setDigimonInfo({ ...digimon, percent: result[0].probability * 100 });
    }
  }, [result]);

  return (
    <Container>
      <Image src={digimonInfo.image} />

      <Content>
        <Top>
          <Name>{digimonInfo.title}</Name>
          <Percent>{digimonInfo.percent.toFixed(2)}% 일치</Percent>
        </Top>
        <Desc>{digimonInfo.desc}</Desc>
      </Content>

      {result && result.length > 0 && (
        <Bottom>
          <ClassAndPercent object={result[0]} />
          <ClassAndPercent object={result[1]} />
          <ClassAndPercent object={result[2]} />
          <ClassAndPercent object={result[3]} />
        </Bottom>
      )}

      <FlexCenter>
        <ImageSaveButton />
      </FlexCenter>
    </Container>
  );
};

export default ResultContent;

const Container = styled.div`
  padding: 10px;

  max-width: 300px;

  margin: auto;
`;

const Image = styled.img`
  width: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Top = styled.div`
  border-radius: 10px;

  padding: 6px;

  background-color: rgba(38, 83, 219, 0.5);
  text-shadow: -2px 0 #000000, 0 2px #000000, 2px 0 #000000, 0 -2px #000000;

  color: white;

  display: flex;
  flex-direction: column;

  gap: 4px;
`;

const Name = styled.div`
  font-size: 30px;
  color: #ffcd4a;
`;
const Percent = styled.div`
  font-size: 16px;
`;

const Desc = styled.div`
  border-radius: 10px;

  padding: 6px;

  background-color: rgba(38, 83, 219, 0.5);
  text-shadow: -2px 0 #000000, 0 2px #000000, 2px 0 #000000, 0 -2px #000000;

  color: white;

  white-space: pre-line;
`;

const Bottom = styled.div`
  width: 100%;
  background-color: rgba(38, 83, 219, 0.3);
  border-radius: 10px;

  display: flex;
  flex-direction: column;
  gap: 4px;

  margin-top: 10px;
  margin-bottom: 10px;

  padding: 4px;

  text-shadow: -1px 0 #000000, 0 1px #000000, 1px 0 #000000, 0 -1px #000000;

  color: white;
`;

const FlexCenter = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
